module.exports = __webpack_public_path__ + "assets/img/4.68a19247.png";